import React, { useEffect, useState } from "react";

export default function DepositConfirmationPopup({ isOpen, onClose, onConfirm }) {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      setTimeout(() => setIsAnimating(true), 10);
    } else {
      setIsAnimating(false);
      const timer = setTimeout(() => setIsVisible(false), 300);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  if (!isVisible) return null;

  return (
    <div className={`fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50 transition-opacity duration-300 ${
      isAnimating ? "opacity-100" : "opacity-0"
    }`}>
      <div className={`w-full max-w-sm bg-white rounded-lg p-6 transform transition-all duration-300 ease-in-out ${
        isAnimating ? "scale-100 opacity-100" : "scale-95 opacity-0"
      }`}>
        <h2 className="text-lg font-semibold text-red-600 mb-4">Important Payment Notice!</h2>
        <p className="text-sm text-gray-700 mb-4">
          <span className="font-bold">NEVER</span> modify the payment amount in your banking app!
        </p>
        <ul className="text-sm text-gray-600 list-disc list-inside mb-6 space-y-2">
          <li>Your payment will be <span className="text-red-600 font-bold">REJECTED</span></li>
          <li>Your money will be <span className="text-red-600 font-bold">DEDUCTED</span> from your bank but <span className="text-red-600 font-bold">NOT CREDITED</span> to your account</li>
          <li>Recovery of modified payments is <span className="text-red-600 font-bold">NOT POSSIBLE</span></li>
        </ul>
        <p className="text-sm font-semibold text-gray-800 mb-6">
          Always use EXACTLY the amount you entered.
        </p>

        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 py-2 px-4 text-sm border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className="flex-1 py-2 px-4 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            I Understand
          </button>
        </div>
      </div>
    </div>
  );
}